import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Scales } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Login() {
  const nav = useNavigate();
  const { login, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      toast.success("Willkommen zurück");
      nav("/app/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Anmeldung fehlgeschlagen");
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-[#1A2238] text-white relative overflow-hidden">
        <Link to="/" className="flex items-center gap-2">
          <Scales weight="duotone" size={28} />
          <span className="font-serif text-2xl tracking-tight">Lex<span className="text-[#D32F2F]">Auto</span></span>
        </Link>
        <div className="max-w-md">
          <p className="overline text-[#D32F2F] mb-4">Kanzleisoftware Verkehrsrecht</p>
          <h2 className="font-serif text-5xl leading-tight mb-6">„Eine Akte in 47 Sekunden. Das ist keine Software — das ist ein <span className="italic">Kollege.</span>"</h2>
          <p className="text-white/70">— Dr. A. Schneider, Fachanwalt für Verkehrsrecht</p>
        </div>
        <p className="text-xs text-white/40">© 2026 LexAuto · DSGVO · Hosting in Deutschland</p>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md space-y-8" data-testid="login-form">
          <div>
            <Link to="/" className="lg:hidden flex items-center gap-2 mb-8">
              <Scales weight="duotone" size={24} className="text-[#1A2238]" />
              <span className="font-serif text-xl">LexAuto</span>
            </Link>
            <p className="overline text-[#D32F2F] mb-3">Anmeldung</p>
            <h1 className="font-serif text-4xl tracking-tight">Willkommen zurück</h1>
            <p className="text-[#4B5563] mt-2 text-sm">Melden Sie sich in Ihrer Kanzlei-Umgebung an.</p>
          </div>
          <div className="space-y-4">
            <div>
              <Label htmlFor="email" className="overline text-[#4B5563]">E-Mail</Label>
              <Input id="email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="mt-2" data-testid="login-email-input" />
            </div>
            <div>
              <Label htmlFor="password" className="overline text-[#4B5563]">Passwort</Label>
              <Input id="password" type="password" required value={password} onChange={e => setPassword(e.target.value)} className="mt-2" data-testid="login-password-input" />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-[#1A2238] hover:bg-[#2C3859]" data-testid="login-submit-btn">
            {loading ? "Anmelden..." : "Anmelden"}
          </Button>
          <p className="text-sm text-[#4B5563] text-center">
            Noch keine Kanzlei? <Link to="/register" className="text-[#1A2238] underline decoration-[#D32F2F]" data-testid="login-to-register-link">Jetzt kostenlos einrichten</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
